/*
 * Hartwick Atelier — Welcome panel (region and language before the site).
 * Markup and reasoning: snippets/ha-welcome.liquid.
 *
 * <head> has already added html.ha-welcome-open when the visitor has no
 * ha_entered cookie. This file:
 *   - makes the rest of the page inert while the panel is up;
 *   - preselects the detected country when Shopify reports one we sell to;
 *   - on Continue, writes the cookie and either just closes (nothing
 *     changed) or lets the /localization form post (country or language
 *     changed — Shopify redirects back to this page in the new market).
 */
(function () {
  var root = document.documentElement;
  var panel = document.getElementById('HaWelcome');
  if (!panel) return;
  if (!root.classList.contains('ha-welcome-open')) return;

  var form = panel.querySelector('form');
  var country = panel.querySelector('[data-ha-welcome-country]');
  var language = panel.querySelector('[data-ha-welcome-language]');
  var remember = panel.querySelector('[data-ha-welcome-remember]');
  var startCountry = panel.getAttribute('data-current-country');
  var startLanguage = panel.getAttribute('data-current-language');
  var others = [];

  Array.prototype.forEach.call(document.body.children, function (el) {
    if (el === panel || el.tagName === 'SCRIPT' || el.inert) return;
    el.inert = true;
    others.push(el);
  });
  if (country) country.focus({ preventScroll: true });

  function setCookie() {
    var c = 'ha_entered=1; path=/; SameSite=Lax';
    if (remember && remember.checked) c += '; max-age=' + 60 * 60 * 24 * 365;
    document.cookie = c;
  }

  function close() {
    others.forEach(function (el) { el.inert = false; });
    root.classList.remove('ha-welcome-open');
    panel.hidden = true;
  }

  /* Detection only preselects; nothing is switched until Continue. The
     visitor's own change of the select always wins over a late answer. */
  var touched = false;
  if (country) country.addEventListener('change', function () { touched = true; });
  fetch('/browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(startCountry),
    { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      if (touched || !data || !data.suggestions || !data.suggestions.length) return;
      var parts = data.suggestions[0].parts || {};
      var code = parts.country && parts.country.handle;
      if (code && country && country.querySelector('option[value="' + code + '"]')) country.value = code;
    })
    .catch(function () {});

  /* Back to the page they came for, without the review switch. */
  var back = form.querySelector('[name="return_to"]');
  if (back) back.value = back.value.replace(/([?&])ha_welcome=1(&|$)/, '$1').replace(/[?&]$/, '');

  /* --- the cookie bar ----------------------------------------------------
     Shown when Shopify's own banner is not (it appears only where the law
     requires it) and this browser has not answered yet. The answer goes to
     Shopify's Customer Privacy API, so analytics and pixels follow it. */
  var consent = panel.querySelector('[data-ha-consent]');
  function answered() { return /(^|;\s*)ha_consent=/.test(document.cookie); }
  function withPrivacy(cb) {
    if (window.Shopify && window.Shopify.customerPrivacy) return cb(window.Shopify.customerPrivacy);
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err && window.Shopify.customerPrivacy) cb(window.Shopify.customerPrivacy);
      });
    }
  }
  function shopifyBannerShowing() {
    var b = document.getElementById('shopify-pc__banner');
    return !!(b && b.offsetHeight && getComputedStyle(b).visibility !== 'hidden');
  }
  if (consent && !answered()) {
    withPrivacy(function (cp) {
      var shopifyAsks = typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner();
      if (shopifyAsks || shopifyBannerShowing()) return;
      consent.hidden = false;
      panel.classList.add('ha-welcome--consent');
    });
    consent.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ha-consent-choice]');
      if (!btn) return;
      var choice = btn.getAttribute('data-ha-consent-choice');
      if (choice === 'prefs') {
        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
          window.privacyBanner.showPreferences();
        }
        return;
      }
      var yes = choice === 'accept';
      withPrivacy(function (cp) {
        cp.setTrackingConsent({ analytics: yes, marketing: yes, preferences: yes, sale_of_data: yes }, function () {});
      });
      document.cookie = 'ha_consent=' + (yes ? 'yes' : 'no') + '; path=/; max-age=' + 60 * 60 * 24 * 365 + '; SameSite=Lax';
      consent.hidden = true;
      panel.classList.remove('ha-welcome--consent');
    });
  }

  form.addEventListener('submit', function (event) {
    setCookie();
    var sameCountry = !country || country.value === startCountry;
    var sameLanguage = !language || language.value === startLanguage;
    if (sameCountry && sameLanguage) {
      event.preventDefault();
      close();
    }
  });
})();
